import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { BASE_STAT_WIDTH } from 'modules/common/const';

import statsImage from '../../assets/stats-bg.jpg';
import statsMobileImage from '../../assets/stats-bg-mobile.jpg';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: `1fr ${BASE_STAT_WIDTH}px ${BASE_STAT_WIDTH}px`,
    gap: theme.spacing(3),

    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },

  card: {
    '&&': {
      display: 'grid',
      gridTemplateColumns: '1fr max-content',
      gridTemplateRows: '30px 1fr',
      justifyContent: 'space-between',

      padding: theme.spacing(4, 4.5),

      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(2, 4.5, 4),
      },
    },
  },

  myStakedCard: {
    width: '100%',
    flex: 1,
    minHeight: 150,

    backgroundImage: `url(${statsImage})`,
    backgroundSize: 'cover',

    '&:before': {
      display: 'none',
    },

    [theme.breakpoints.down('md')]: {
      backgroundImage: `url(${statsMobileImage})`,
      minHeight: 136,
    },
  },

  commonCard: {
    width: '100%',
    maxWidth: 320,
    minHeight: 150,

    [theme.breakpoints.down('md')]: {
      minHeight: 100,
      maxWidth: '100%',
    },
  },

  label: {
    fontWeight: 600,
    color: alpha(theme.palette.text.primary, 0.6),
    alignSelf: 'center',
  },

  amount: {
    gridRow: 2,
    gridColumn: '1 / span 2',
    alignSelf: 'flex-end',
  },

  amounts: {
    display: 'flex',
    alignItems: 'center',
  },

  link: {
    display: 'flex',
    width: 76,
    cursor: 'pointer',
    position: 'relative',

    '& > img': {
      width: '100%',
    },
  },

  divider: {
    height: 12,
    width: 1,
    background: theme.palette.text.primary,
    margin: theme.spacing(0, 1.5),
  },
}));
